import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect, useRef } from "react";
import "./b2chashing.css";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";
import swal from "sweetalert";
import Axios from "axios";

const B2chashing = () => {
  const [barcode, setBarcode] = useState("");
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const [Dataa, setDataa] = useState([]);
  const [totalScanned, setTotalScanned] = useState(0);
  const [loading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("method1");
  const barcodeInputRef = useRef(null);
  const [barcodek, setBarcodek] = useState("");

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getManageshelf`).then(
      (response) => {
        setDataa(response.data);
      }
    );
  }, []);

  const addBarcode = async (newBarcode) => {
    try {
      setBarcodek("");
      const response = await Axios.get(
        `${INVENTORY_API_BASE_URL}/getKey/${newBarcode}`
      );
      const key = response.data.key;

      if (key) {
        const isBarcodeMatched = Dataa.some((ite) =>
          ite.barcodeData?.includes(key)
        );

        if (isBarcodeMatched) {
          if (!scannedBarcodes.includes(key)) {
            setScannedBarcodes((prevBarcodes) => [...prevBarcodes, key]);
            setTotalScanned((prevTotal) => prevTotal + 1);
            alertify.success("Barcode Scan Successfully", 3);

            const dataToSend = {
              barcodeData: [key],
              count: 1,
            };

            const endpoints = {
              method1: `${INVENTORY_API_BASE_URL}/flipkartB2C`,
              method2: `${INVENTORY_API_BASE_URL}/AmazonB2C`,
              method3: `${INVENTORY_API_BASE_URL}/PinnacleB2C`,
              method4: `${INVENTORY_API_BASE_URL}/EmployeeB2C`,
              method5: `${INVENTORY_API_BASE_URL}/ScrapB2C`,
              method6: `${INVENTORY_API_BASE_URL}/SnapdealB2C`,
              method7: `${INVENTORY_API_BASE_URL}/MeeshuB2C`,
            };

            const selectedURL = endpoints[selectedMethod];

            await Axios.post(selectedURL, dataToSend);
            await Axios.delete(
              `${INVENTORY_API_BASE_URL}/putawayOutbound`,
              {
                data: { barcodeData: [key] },
              }
            );

          } else {
            alertify.error("Barcode already scanned", 3);
          }
        } else {
          alertify.error("Scan Correct Barcode", 3);
        }
      } else {
        alertify.error("Key not found for the given value", 3);
      }
    } catch (error) {
      console.error("Error during barcode scan:", error);
    }
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      const clickedElement = event.target;
      if (
        clickedElement !== barcodeInputRef.current &&
        !clickedElement.closest(".B2C") &&
        !clickedElement.closest(".flipkart") &&
        !clickedElement.closest(".btn.btn-primary")
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <main className="bechashing-container b2c-page">
      <div className="b2c-workspace">
        <header className="b2c-page-header">
          <div className="b2c-title-block">
            <span className="b2c-eyebrow">INVENTORY / OUTBOUND</span>
            <h1>B2C Outbound</h1>
            <p>Send scanned stock to the selected sales channel.</p>
          </div>

          <div className="b2c-channel-picker">
            <label htmlFor="b2c-channel">Sales channel</label>
            <select
              id="b2c-channel"
              value={selectedMethod}
              className="B2C b2c-channel"
              onChange={(e) => setSelectedMethod(e.target.value)}
            >
              <option value="method1">Flipkart B2C</option>
              <option value="method2">Amazon B2C</option>
              <option value="method3">Pinnacle B2C</option>
              <option value="method4">Youtuber Influencer</option>
              <option value="method5">Scrap</option>
              <option value="method6">Snapdeal B2C</option>
              <option value="method7">Meesho B2C</option>
            </select>
          </div>
        </header>

        <div className="b2c-dashboard-grid">
          <section className="b2c-scan-panel" aria-labelledby="b2c-scan-title">
            <div className="b2c-panel-heading">
              <div>
                <span className="b2c-section-label">SCAN STATION</span>
                <h2 id="b2c-scan-title">Scan a barcode</h2>
                <p>Scan a code and press Enter to process it automatically.</p>
              </div>
              <span className="b2c-autosave-badge">
                <span aria-hidden="true" />
                Auto-save on
              </span>
            </div>

            <label className="b2c-input-label" htmlFor="b2c-barcode">
              Barcode or product code
            </label>
            <div className="b2c-input-wrap">
              <svg
                className="b2c-input-icon"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path d="M4 5v14M7 5v14M10 5v14M14 5v14M17 5v14M20 5v14" />
              </svg>
              <input
                id="b2c-barcode"
                className="b2csearch"
                type="text"
                ref={barcodeInputRef}
                value={barcodek}
                onChange={(e) => setBarcodek(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addBarcode(barcodek);
                  }
                }}
                placeholder="Scan or enter barcode"
                autoComplete="off"
              />
            </div>
            <p className="b2c-input-hint">
              The scan field stays ready for your next barcode.
            </p>

            {loading && (
              <div className="b2c-processing-state" role="status">
                <span className="b2c-spinner" aria-hidden="true" />
                Completing outbound…
              </div>
            )}
          </section>

          <aside className="b2c-total-panel" aria-label="Session scan total">
            <span className="b2c-total-kicker">SESSION TOTAL</span>
            <strong className="b2c-total-value">
              {totalScanned.toLocaleString()}
            </strong>
            <span className="b2c-total-caption">barcodes scanned</span>
            <div className="b2c-total-note">
              <span className="b2c-total-dot" aria-hidden="true" />
              Scans accepted this session
            </div>
          </aside>
        </div>

        <section className="b2c-recent-panel" aria-labelledby="b2c-recent-title">
          <div className="b2c-recent-heading">
            <div>
              <span className="b2c-section-label">ACTIVITY</span>
              <h2 id="b2c-recent-title">Recent scans</h2>
            </div>
            <span className="b2c-recent-count">
              {scannedBarcodes.length.toLocaleString()} total
            </span>
          </div>

          {scannedBarcodes.length > 0 ? (
            <ul className="b2c-recent-list">
              {scannedBarcodes
                .slice(-6)
                .reverse()
                .map((code, index) => (
                  <li key={[code, index].join("-")}>
                    <span className="b2c-recent-code" title={code}>
                      {code}
                    </span>
                    <span className="b2c-scan-label">Scanned</span>
                  </li>
                ))}
            </ul>
          ) : (
            <div className="b2c-recent-empty">
              <span className="b2c-empty-icon" aria-hidden="true">
                —
              </span>
              <p>Recent barcode scans will appear here.</p>
            </div>
          )}
        </section>
      </div>
    </main>
  );
};
export default B2chashing;
